import { useState } from "react";
import DashboardDietPlan from "@features/dashboard/DietPlanView";
import ExercisePlanView from "@features/dashboard/ExercisePlanView";
import {
  NoDietPlan,
  NoExercise
} from "@utils/defaultImages";
import ActualDietPlanLoader from "@components/ui/Loaders/ActualDietPlanLoader";
import MainHeader from "@components/ui/MainHeader";
import HeaderImage from "@assets/images/dashboardHeader.svg";
import { useTranslation } from "react-i18next";
import SingleDayMindfulness from "@features/dashboard/Mindfulness";
import SingleDaySleepCoach from "@features/dashboard/SleeoCoachSuggestion";
import { useDashboardData } from "@hooks/useDashboardData";
import { getInitialTab } from "@utils/getInitialTab";
import EmptyPlanView from "@components/ui/EmptyPlanView";

const Home = () => {
  const { t } = useTranslation();

  const {
    loading,
    selectedMeal,
    exerciseData,
    selectedMeals,
    mindfulnessPlan,
    sleepCoach,
    setMindfulnessPlan,
  } = useDashboardData();

  const [tab, setTab] = useState(() => getInitialTab());

  return (
    <div>
      {loading ? (
        <ActualDietPlanLoader dashboard={true} />
      ) : (
        <>
          <MainHeader
            heading={t(`dashboard.headerHeading`)}
            subheading={t(`dashboard.headerSubHeading`)}
            description={t(`dashboard.headerDescription`)}
            Image={HeaderImage}
          />

          <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 mt-5">
            {/* Diet Plan Section */}
            <div className={`bg-white rounded-lg bg-[white] w-full`}>
              {selectedMeal ? (
                <DashboardDietPlan
                  tab={tab}
                  setTab={setTab}
                  selectedMeal={selectedMeal}
                  selectedMeals={selectedMeals}
                />
              ) : (
                <EmptyPlanView
                  IconComponent={<NoDietPlan />}
                  heading={t("dashboard.noDietPlanDataHeading")}
                  description={t("dashboard.noDietPlanDatadescription")}
                />
              )}
            </div>

            {/* Exercise Plan Section */}
            {exerciseData ? (
              <ExercisePlanView exerciseData={exerciseData} />
            ) : (
              <EmptyPlanView
                IconComponent={<NoExercise />}
                heading={t("dashboard.noExercisePlanDataHeading")}
                description={t("dashboard.noExercisePlanDatadescription")}
              />
            )}
          </div>

          {/* Mindfulness and Sleep Coach Section */}
          <div className="space-y-5 mt-5">
            <SingleDayMindfulness
              mindfulnessPlan={mindfulnessPlan}
              setMindfulnessPlan={setMindfulnessPlan}
            />
            <SingleDaySleepCoach sleepAdvice={sleepCoach} />
          </div>
        </>
      )}
    </div>
  );
};

export default Home;
